<template>
  <fieldset>
    <legend>
      <span class="pull-left">{{ $t("form.special_saving.legend") }}</span>
      <!-- <a class="fa fa-question-circle" @click="displayModal($event, 0)" /> -->
      <a
        class="pull-right"
        ref="collapseLink"
        data-toggle="collapse"
        href="#collapse_special_saving"
        role="button"
        aria-expanded="true"
        aria-controls="collapse_special_saving"
      >
        <span class="fa fa-angle-up"></span>
        <span class="fa fa-angle-down"></span>
      </a>
    </legend>

    <modal v-show="modals[0]" @close="$set(modals, 0, false)">
      <h2 slot="modal-header">{{ $t("form.special_saving.legend") }}</h2>
      <div slot="modal-body"></div>
    </modal>

    <div
      class="collapse show"
      id="collapse_special_saving"
      ref="collapseElement"
    >
      <div class="form-group">
        <label for="savingPercent">{{
          $t("form.special_saving.savingPercent.label")
        }}</label>
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            id="savingPercent"
            :placeholder="$t('form.special_saving.savingPercent.placeholder')"
            v-model="specialSaving.savingPercent"
            @invalid="expandContent($refs.collapseLink, $refs.collapseElement)"
            required
          />
          <div class="invalid-feedback">
            <invalid-cross></invalid-cross>
            <span>{{ $t("form.validation_error_message") }}</span>
          </div>
        </div>
      </div>

      <label>Aftale om disponering af særlig opsparing</label>
      <div>
        <label for="special_saving_deal_one">
          <input
            type="radio"
            id="special_saving_deal_one"
            value="one"
            v-model="specialSaving.deal"
          />
          {{ $t("form.special_saving.deal.one") }}
        </label>
      </div>

      <div>
        <label for="special_saving_deal_two">
          <input
            type="radio"
            id="special_saving_deal_two"
            value="two"
            v-model="specialSaving.deal"
          />
          {{ $t("form.special_saving.deal.two") }}
        </label>
      </div>

    </div>
  </fieldset>
</template>

<script>
export default {
  data() {
    return {
      specialSaving: {
        savingPercent: "",
        deal: "",
      },
    };
  },
  watch: {
    specialSaving: {
      handler() {
        this.$store.commit("updateSpecialSaving", this.specialSaving);
      },
      deep: true,
    },
  },
};
</script>
